export default __webpack_public_path__ + "media/flavours/glitch/images/mbstobon-ui-1-c3aa4ba2dca2c406fa32e9ebee0d362b.png";